/**
 * Analytics utilities — formatters, helpers, custom hooks
 */
import React from "react";

export const formatLargeNumber = (num) => {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toString();
};

export const formatPercent = (percent) => {
  if (percent === 0) return "→ 0%";
  const sign = percent > 0 ? "↑" : "↓";
  return `${sign} ${Math.abs(percent)}%`;
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
};

export const formatTime = (isoString) => {
  if (!isoString) return "-";
  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

  if (diffHours < 24) {
    if (diffHours === 0) return "Hace menos de 1 hora";
    return `Hace ${diffHours}h`;
  }
  if (diffDays === 1) return "Ayer";
  if (diffDays < 7) return `Hace ${diffDays}d`;
  return date.toLocaleDateString("es-ES");
};

export const getTrendColor = (percent) => {
  if (percent > 0) return "text-emerald-600";
  if (percent < 0) return "text-red-600";
  return "text-gray-600";
};

export const getTrendBg = (percent) => {
  if (percent > 0) return "bg-emerald-50";
  if (percent < 0) return "bg-red-50";
  return "bg-gray-50";
};

export const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-gray-200 rounded shadow-lg p-2 text-xs">
        <p className="font-medium text-gray-900">
          {payload[0].payload.date || payload[0].payload.hour}
        </p>
        {payload.map((entry, i) => (
          <p key={i} style={{ color: entry.color }} className="text-xs">
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export const useFetchAnalytics = (authAxios, period) => {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await authAxios.get(`/chatbot/analytics?days=${period}`);
        setData(res.data);
        setError(false);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [period, authAxios]);

  return { data, loading, error };
};
